import Shipments from "../../../containers/shipments/shipments";
import { getApiUrl } from "../../../utils/baseUrl";
import { filterTypeDictionary as filterType, analyticsTypeDictionary as analyticsType, autoSuggestLanguageDictionary as autosuggestLanguageOptions, redirectingProfileEnum, categoryType } from "../../../core/global/global-country-dictionary";
import { globalCountryDetailsDictionary as globalCountryDetails } from "../../../core/global/global-country-details";

export const analyticDropdownOptions = [
  { value: "shipments", label: "Number of Shipments", two_table_header: "Total Shipments" },
  { value: "value", label: "Total FOB Value (USD)", two_table_header: "Total FOB Value (USD)" },
  { value: "weight", label: "Total Gross Weight (kg)", two_table_header: "Total Gross Weight (kg)" },
];
export const trendsDropdownOptions = [
  { value: "shipments", label: "Shipments", table_header: "Total Shipments" },
  { value: "value", label: "Value (USD)", table_header: "Total Value (USD)" },
  { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
];

export const defaultData = {
  name: "Ecuador Exports",
  customShipmentGrid: true,
  showUiUeLevelTwo: true,
  isProductChemicalPresent: true,
  analyticsDefault: analyticDropdownOptions[0].value,
  analyticsRangeDownloadPresent: true,
  isFilterGroupingPresent: true,
  isViewAllGridNew: true,
  showUiTrends: true,
  isShipmentGridNew: true,
  exportPDFInAnalytics: false,
  minimumDateAllowed: "2019-01-01",
  isImpExpGraph: true,
  isUIGridNew: true,
  isUEGridNew: true,
  trendsTableCompanyID: {
    shipper: "hashed_id",
    consignee: "hashed_id",
  },
  importer_exporter_graph_sort__options: [
    { value: "shipment_value", label: "Value (USD)", table_header: "Total Shipment Value(USD)" },
    { value: "doc_count", value1: "date", label: "Shipments", table_header: "Total Shipments" },
    { value: "weight", label: "Weight (kg)", table_header: "Total Weight (kg)" },
  ],
  apiEndPoints: {
    getArrivalDate: getApiUrl("ecuadorExportLatestArrivalDate"),
    getSearchResult: getApiUrl("ecuadorExportSearch"),
    getAnalyticsData: getApiUrl("analytics/ecuadorExportAnalytics"),
    saveProspectiveExportersApi: "addFavouriteCompany",
    saveProspectiveImportersApi: "addFavouriteCompany",
    downloadShipmentsApi: getApiUrl("create_excel_ecuador_exports"),
    downloadUniqueImporterExporter: getApiUrl("create_excel_ecuador_exports"),
    getShipmentByID: getApiUrl("ecuadorExportShipmentByID"),
    getShipmentDownloadData: getApiUrl("renderToPdfEcuadorExports"),
    renderToPdfAnalytics: getApiUrl("renderToPdfAnalytics"),
    getUserPlanDetails: getApiUrl("getUserCreditsByPlan"),
    getCompanySlug: getApiUrl("companyProfiles/getSlug"),
    getSavedSearchPayloadById: getApiUrl("getSavedSearchPayloadById"),
    getMasterListsForAutoSearchFeilds: getApiUrl("dashboard/getMasterListsForAutoSearchFeilds"),
    getAnalyticsViewAll: getApiUrl("analytics/ecuadorExportAnalyticsViewAll"),
    getMissingTabData: getApiUrl("intelSearchWhatAreMissing"),
    getImpExpGraphData: getApiUrl("intelSearchEcuadorExportGraph"),
  },
  isAdvancedSearchAvailable: false,
  country_small: globalCountryDetails.ec_export.country_small,
  countryCaps: globalCountryDetails.ec_export.country_caps,
  product_id: globalCountryDetails.ec_export.product_id,
  compare_product_id: globalCountryDetails.ec_export.compareProduct,
  country_CamelCase: globalCountryDetails.ec_export.product_id,
  countryCode: globalCountryDetails.ec_export.countryCode,
  countryType: globalCountryDetails.ec_export.countryType,
  manyCountryType: globalCountryDetails.ec_export.manyCountryType,
  countryTypeCode: globalCountryDetails.ec_export.countryTypeCode,
  redirectionID: globalCountryDetails.ec_export.redirectionID,
  analyticsCountryID: globalCountryDetails.ec_export.analyticsCountryID,
  autoSuggestLanguage: autosuggestLanguageOptions.english,
  dateRangeHeading: "Shipment Date Range",
  monthRangeHeading: "Month of Export",
  picker: {
    monthPicker: false,
    datePicker: true,
  },
  tabKeyWords: {
    shipments: true,
    analytics: true,
    exporters: true,
    importers: true,
    whatYouAreMissing: true,
  },
  main_dropdown_options: {
    entire_bill_of_lading: false,
    product_description: true,
    product_hscode: true,
    exporters: true,
    importers: true,
    allCategory: true,
    ports: true,
    chemical_description: true,
  },
  searchCategoryList: globalCountryDetails.ec_export.defaultDropDown,
  specialFields: {
    hscode: "hsCode",
    consignee: "derivedConsigneeMasterName",
    shipper: "derivedShipperMasterName",
    weight: "weight",
    teu: "teu",
    value: "shipmentValue",
    productCategory: "productCategory",
    sixDigitHsCode: "sixDigitHsCode",
    portOfUnlading: "standardUnladingPortRegion",
    portOfLading: "standardLadingPortName",
  },
  filterObj: {
    countryOfDestinationRegion: "countryOfDestinationRegion",
    countryOfExportRegion: "countryOfExportRegion",
    consignee: "consignee",
    isImporter: "isImporter",
    shipper: "shipper",
    isExporter: "isExporter",
    standardLadingPortName: "standardLadingPortName",
    standardUnladingPortRegion: "standardUnladingPortRegion",
    customsAgentName: "customsAgentName",
    customsAgencyName: "customsAgencyName",
    typeOfExport: "typeOfExport",
    modeOfTransport: "modeOfTransport",
    carrierName: "carrierName",
    hsCode: "hsCode",
    productCondition: "productCondition",
    containers: "containers",
    shipmentValue: "shipmentValue",
    weight: "weight",
    derivedConsigneeMasterName: "derivedConsigneeMasterName",
    derivedShipperMasterName: "derivedShipperMasterName",
    sixDigitHsCode: "sixDigitHsCode",
    productCategory: "productCategory",
    industryCategory: "industryCategory",
    quantityUnit: "quantityUnit",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountryRegion",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountryRegion",
  },
  booleanFilterObj: {
    exclude_blank_consignee: "exclude_blank_consignee",
    exclude_blank_shipper: "exclude_blank_shipper",
  },
  boxRangeFilterList: {
    weight: "weight",
    containers: "containers",
    shipmentValue: "shipmentValue",
    perUnitValue: "perUnitValue",
    quantityRange: "quantityRange",
  },
  boxFilterObj: {
    weight: [],
    containers: [],
    shipmentValue: [],
    perUnitValue: [],
    quantityRange: [],
  },
  localisationFilterObj: {
    countryOfDestinationRegion: "countryOfDestination",
    countryOfExportRegion: "countryOfExport",
    standardUnladingPortRegion: "standardUnladingPortName",
    consigneeJurisdictionCountryRegion: "consigneeJurisdictionCountry",
    shipperJurisdictionCountryRegion: "shipperJurisdictionCountry",
  },
  emptyFilterObj: {
    countryOfDestinationRegion: [],
    countryOfExportRegion: [],
    consignee: [],
    isImporter: [],
    shipper: [],
    isExporter: [],
    standardLadingPortName: [],
    standardUnladingPortRegion: [],
    customsAgentName: [],
    customsAgencyName: [],
    typeOfExport: [],
    modeOfTransport: [],
    carrierName: [],
    hsCode: [],
    productCondition: [],
    containers: [],
    shipmentValue: [],
    weight: [],
    sections: [],
    derivedConsigneeMasterName: [],
    derivedShipperMasterName: [],
    sixDigitHsCode: [],
    productCategory: [],
    industryCategory: [],
    quantityUnit: [],
    perUnitValue: [],
    quantityRange: [],
    consigneeJurisdictionCountryRegion: [],
    shipperJurisdictionCountryRegion: [],
  },
  defaultBooleanFilterObj: {
    exclude_blank_consignee: false,
    exclude_blank_shipper: false,
  },
  selectAll: {
    countryOfDestinationRegion: false,
    countryOfExportRegion: false,
    consignee: false,
    isImporter: false,
    shipper: false,
    isExporter: false,
    standardLadingPortName: false,
    standardUnladingPortRegion: false,
    customsAgentName: false,
    customsAgencyName: false,
    typeOfExport: false,
    modeOfTransport: false,
    carrierName: false,
    hsCode: false,
    productCondition: false,
    containers: false,
    shipmentValue: false,
    weight: false,
    sections: false,
    derivedConsigneeMasterName: false,
    derivedShipperMasterName: false,
    sixDigitHsCode: false,
    productCategory: false,
    industryCategory: false,
    quantityUnit: false,
    perUnitValue: false,
    quantityRange: false,
    consigneeJurisdictionCountryRegion: false,
    shipperJurisdictionCountryRegion: false,
  },
  specialMappingFields: {
    derived_hs_codes_string: {
      derived_hs_codes_string: {
        key: "derived_hs_codes_string",
        value: "",
      },
      derived_hs_codes_string_estimated: {
        key: "derived_hs_codes_string_estimated",
        value: "",
      },
      derived_hs_codes_string_estimated_is_present: {
        key: "derived_hs_codes_string_estimated_is_present",
        value: "Estimated HSCode",
      },
      fallback: "Not Available",
    },
    derived_shipment_value: {
      derived_shipment_value: {
        key: "derived_shipment_value",
        value: "",
      },
      derived_shipment_value_is_present: {
        key: "derived_shipment_value_is_present",
        value: "",
      },
      fallback: "Not Available",
    },
    shipper_party_name: {
      shipper_party_name: {
        key: "shipper_party_name",
        value: "",
      },
      fallback: "Not Declared",
    },
  },
  normalfilterList: [
    { heading: "Filter by Consignee Standardized Name", categoryName: "consigneeDetails", eventKey: "19", key: "derivedConsigneeMasterName", type: filterType.normalFilter, label: "Consignee Standardized Name", viewAllPlaceHolder: "Search in Consignee Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Standardized Name", categoryName: "shipperDetails", eventKey: "20", key: "derivedShipperMasterName", type: filterType.normalFilter, label: "Shipper Standardized Name", viewAllPlaceHolder: "Search in Shipper Standardized Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Name", categoryName: "consigneeDetails", eventKey: "3", key: "consignee", type: filterType.normalFilter, label: "Consignee Name", viewAllPlaceHolder: "Search in Consignee Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipper Name", categoryName: "shipperDetails", eventKey: "2", key: "shipper", type: filterType.normalFilter, label: "Shipper Name", viewAllPlaceHolder: "Search in Shipper Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Import", categoryName: "consigneeDetails", eventKey: "1", key: "countryOfDestinationRegion", altKey: "countryOfDestination", type: filterType.localizeFilter, label: "Country of Import", viewAllPlaceHolder: "Search in Country of Import Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Country of Export", categoryName: "shipperDetails", eventKey: "1", key: "countryOfExportRegion", altKey: "countryOfExport", type: filterType.localizeFilter, label: "Country of Export", viewAllPlaceHolder: "Search in Country of Export Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Consignee Type", categoryName: "consigneeDetails", eventKey: "4", key: "isImporter", type: filterType.normalFilter, label: "Consignee Type", viewAllPlaceHolder: "Search in Is Importer Filter", emptyFilterText: "", searchFilterString: "", isTitleCase: true },
    { heading: "Filter by Shipper Type", categoryName: "shipperDetails", eventKey: "5", key: "isExporter", type: filterType.normalFilter, label: "Shipper Type", viewAllPlaceHolder: "Search in Is Exporter Filter", emptyFilterText: "", searchFilterString: "", isTitleCase: true },
    { heading: "Filter by Customs House Name", categoryName: "ports", eventKey: "7", key: "standardLadingPortName", type: filterType.normalFilter, label: "Customs House Name", viewAllPlaceHolder: "Search in Customs House Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Agent Name", categoryName: "ports", eventKey: "8", key: "customsAgentName", type: filterType.normalFilter, label: "Customs Agent Name", viewAllPlaceHolder: "Search in Customs Agent Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Customs Agency Name", categoryName: "ports", eventKey: "9", key: "customsAgencyName", type: filterType.normalFilter, label: "Customs Agency Name", viewAllPlaceHolder: "Search in Customs Agency Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Port Of Unlading", categoryName: "ports", eventKey: "6", key: "standardUnladingPortRegion", altKey: "standardUnladingPortName", type: filterType.localizeFilter, label: "Port Of Unlading", viewAllPlaceHolder: "Search in Port Of Unlading Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Export Type", categoryName: "freightType", eventKey: "10", key: "typeOfExport", type: filterType.normalFilter, label: "Export Type", viewAllPlaceHolder: "Search in Export Type Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Mode of Transportation", categoryName: "freightType", eventKey: "11", key: "modeOfTransport", type: filterType.normalFilter, label: "Mode of Transportation", viewAllPlaceHolder: "Search in Mode of Transportation Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Carrier Name", categoryName: "carrierDetails", eventKey: "12", key: "carrierName", type: filterType.normalFilter, label: "Carrier Name", viewAllPlaceHolder: "Search in Carrier Name Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Category", categoryName: "cargoDetails", eventKey: "13", key: "productCategory", type: filterType.normalFilter, label: "Product Category", viewAllPlaceHolder: "Search in Product Category Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Industry Group", categoryName: "cargoDetails", eventKey: "33", key: "industryCategory", type: filterType.normalFilter, label: "Industry Group", viewAllPlaceHolder: "Search in Industry Group Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by HS Code", categoryName: "cargoDetails", eventKey: "13", key: "hsCode", type: filterType.hsCodeFilter, label: "HS Code", viewAllPlaceHolder: "Search in HS Code Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Product Condition", categoryName: "cargoDetails", eventKey: "14", key: "productCondition", type: filterType.normalFilter, label: "Product Condition", viewAllPlaceHolder: "Search in Product Condition Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Number of Containers", categoryName: "freightType", eventKey: "15", key: "containers", type: filterType.boxFilter, label: "Number of Containers", viewAllPlaceHolder: "Search in Number of Containers Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Shipment Value", categoryName: "cargoDetails", eventKey: "16", key: "shipmentValue", type: filterType.boxFilter, label: "Value (USD)", viewAllPlaceHolder: "Search in FOB Value Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Weight", categoryName: "cargoDetails", eventKey: "17", key: "weight", type: filterType.boxFilter, label: "Net Weight (kg)", viewAllPlaceHolder: "Search in Net Weight Filter", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by 6 digit HS Code", categoryName: "cargoDetails", eventKey: "9", key: "sixDigitHsCode", type: filterType.normalFilter, label: "6 Digit HS Code", viewAllPlaceHolder: "Type to Search 6 digit HS Code", emptyFilterText: "", searchFilterString: "" },
    { heading: "Filter by Quantity Unit", categoryName: "cargoDetails", eventKey: "32", key: "quantityUnit", additionalKey: "quantityRange", type: filterType.normalFilter, label: "Quantity", viewAllPlaceHolder: "Search Quantity Unit", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: true, isParanthesesCapital: false, additionalType: "multiSelectRangeFilter" },
    { heading: "Filter by Per Unit Value (USD)", categoryName: categoryType.cargoDetails, eventKey: "32", key: "perUnitValue", type: filterType.multiSelectRangeFilter, label: "Per Unit Value (USD)", viewAllPlaceHolder: "", emptyFilterText: "", searchFilterString: "", infoText: "", showInput: false, isParanthesesCapital: false },
    {
      heading: "Filter by Consignee Jurisdiction Country",
      categoryName: "consigneeDetails",
      eventKey: "25",
      key: "consigneeJurisdictionCountryRegion",
      altKey: "consigneeJurisdictionCountry",
      type: "localization-filter",
      label: "Consignee Jurisdiction Country",
      viewAllPlaceHolder: "Search Consignee Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
    {
      heading: "Filter by Shipper Jurisdiction Country",
      categoryName: "shipperDetails",
      eventKey: "25",
      key: "shipperJurisdictionCountryRegion",
      altKey: "shipperJurisdictionCountry",
      type: "localization-filter",
      label: "Shipper Jurisdiction Country",
      viewAllPlaceHolder: "Search Shipper Jurisdiction Country",
      emptyFilterText: "",
      searchFilterString: "",
    },
  ],
  internalFilterList: [
    { isVisible: true, key: "uniqueImportExporterShipment" },
    { isVisible: true, key: "uniqueImportExporterWeight" },
    { isVisible: false, key: "uniqueImportExporterTeu" },
    { isVisible: true, key: "uniqueImportExporterValue" },
  ],
  highLightedColumnList: [
    { key: "refrendo", label: "Refrendo" },
    { key: "declaration_number", label: "Declaration Numbe" },
    { key: "bill_of_lading_number", label: "Bill Of Lading Number" },
    { key: "concimento_emb", label: "Concimento Emb" },
    { key: "shipper_ruc_number", label: "Shipper RUC Number" },
    { key: "shipper_name", label: "Shipper Name" },
    { key: "derived_shipper_master_name", label: "Shipper Name" },
    { key: "consignee_name", label: "Consignee Name" },
    { key: "derived_consignee_master_name", label: "Consignee Standardized Name" },
    { key: "derived_customs_agent_name", label: "Customs Agent Name" },
    { key: "customs_agency_name", label: "Customs Agency Name" },
    { key: "hs_code", label: "HS Code" },
    { key: "product_description_translated", label: "Product Description" },
    { key: "product_description", label: "Product Description (Spanish)" },
    { key: "derived_shipper_parent_company_name", label: "Shipper Parent Company" },
    { key: "derived_consignee_parent_company_name", label: "Consignee Parent Company" },
    { key: "derived_customs_house_name", label: "Customs House" },
    { key: "derived_port_of_unlading", label: "Port of Unlading" },
  ],
  shipmentSorting: [
    { columnKey: "registration_date", value: "date", isDefault: true },
    { columnKey: "net_weight", value: "weight", isDefault: false },
    { columnKey: "fob_value", value: "shipment_value", isDefault: false },
  ],
  exporterSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  importerSorting: [
    { name: "Shipments", columnKey: "doc_count", value: "date", isDefault: false },
    { name: "Weight", columnKey: "weight", value: "weight", isDefault: false },
    { name: "Shipment Value", columnKey: "shipment_value", value: "shipment_value", isDefault: true },
  ],
  sortKeyMap: {
    date: "registration_date",
    weight: "net_weight",
    shipment_value: "fob_value",
  },
  sortKeyUniqueImpExpMap: {
    date: "doc_count",
    weight: "weight",
    shipment_value: "shipment_value",
  },
  analyticsHeaderItems: [
    { label: "Total Number of Shipments", key: "total_shipments", valuePrefix: "", valueSuffix: "" },
    { label: "Total Shipment Value (USD)", key: "total_value", valuePrefix: "USD", valueSuffix: "" },
    { label: "Total Weight", key: "total_weight", valuePrefix: "", valueSuffix: "Kg" },
  ],
  analyticsFieldsMapping: [
    { key: "trade_country_of_export_to_import", filterKey1: "countryOfExportRegion", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Country of Export → Country of Import)", headerOne: "Country of Export", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "derived_consignee_master_name" },
    { key: "trends", filterKey: "", label: "Export Trends", type: analyticsType.trends, showTrends: true, showlevelTwo: false },
    { key: "country_of_destination", filterKey: "countryOfDestinationRegion", label: "Countries of Import", type: analyticsType.horizontalCountry, showTrends: true, showlevelTwo: true, defaultKey: "customs_house_name" },
    { key: "customs_house_name", filterKey: "standardLadingPortName", label: "Customs Houses", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_destination", profileType: redirectingProfileEnum.portOfLading.key },
    { key: "carrier_name", filterKey: "carrierName", label: "Carriers", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_destination" },
    { key: "derived_mode_of_transport_english", filterKey: "modeOfTransport", label: "Mode of Transportation", type: analyticsType.pieChart, showTrends: true, showlevelTwo: true, defaultKey: "country_of_destination" },
    { key: "hs_code", headerLabel: "HS Code", filterKey: "hsCode", label: "HS Codes", type: analyticsType.hsCode, showTrends: false, showlevelTwo: false },
    { key: "port_of_lading", filterKey: "standardUnladingPortRegion", label: "Ports of Unlading", type: analyticsType.horizontalBar, showTrends: true, showlevelTwo: true, defaultKey: "country_of_destination", profileType: redirectingProfileEnum.portOfUnlading.key },
    // { key: "derived_customs_house_name_country_of_destination", filterKey1: "standardLadingPortName", filterKey2: "countryOfDestinationRegion", label: "Trade Routes (Customs House → Country of Import)", headerOne: "Customs House Name", headerTwo: "Country of Import", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "carrier_name" },
    { key: "trade_port", filterKey1: "standardLadingPortName", filterKey2: "standardUnladingPortRegion", label: "Trade Routes (Customs House Name → Port of Unlading)", headerOne: "Customs House Name", headerTwo: "Port of Unlading", filterOne: "filterField1", filterTwo: "filterField2", keyOne: "field1Country", keyTwo: "field2Country", cityOne: "field1", cityTwo: "field2", keyOneCountryCode: "field1CountryCode", keyTwoCountryCode: "field2CountryCode", type: analyticsType.topTwo, showTrends: true, grpType: "multi", showlevelTwo: true, defaultKey: "carrier_name" },
    { key: "six_digit_hs_code", headerLabel: "6 digit HS Code", filterKey: "sixDigitHsCode", label: "6 digit HS Codes", type: analyticsType.hsCode, showTrends: true, showlevelTwo: true, defaultKey: "derived_shipper_master_name" },
  ],
  searchTableColumns: [
    { key: "", name: "View", selector: "", dataTip: "", type: "viewShipment", button: true, staticField: true, grow: 0, miWidth: "40px", maWidth: "40px" },
    { key: "s_no", name: "S No", selector: "s_no", dataTip: "", type: "", maxWidth: "84px !important", minWidth: "84px !important", grow: 0, wrap: true, staticField: true, miWidth: "60px", maWidth: "60px" },
    { key: "registration_date", name: "Registration Date", selector: "registration_date", dataTip: "", type: "", dateFormat: "MMM DD, YYYY", sortable: true, grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "matched_column", name: "Matching Fields", selector: "matched_column", dataTip: "", type: "matchingField", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "hs_code", name: "HS Code", selector: "hs_code", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "product_description", name: "Product", selector: "product_description", tooltipValue: "product_description", type: "", grow: 2, wrap: true, isSliceEnabled: true, sliceLength: 30, miWidth: "120px", maWidth: "120px" },
    { key: "quantity", name: "Quantity", selector: "quantity", secondarySelector: "derived_unit_of_measure_english", dataTip: "", type: "", grow: 0, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "net_weight", name: "Net Weight (kg)", selector: "net_weight", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
    { key: "derived_shipper_master_name", name: "Shipper", selector: "derived_shipper_master_name", alternateSelector: "shipper_name", id: "derived_shipper_master_company_id", dataTip: "", type: "companyRedirect", companyType: "E", grow: 1, wrap: true, miWidth: "140px", maWidth: "140px" },
    { key: "derived_consignee_master_name", name: "Consignee Name", selector: "derived_consignee_master_name", alternateSelector: "consignee_name", id: "derived_consignee_master_company_id", dataTip: "", type: "companyRedirect", companyType: "I", grow: 1, wrap: true, miWidth: "120px", maWidth: "120px" },
    { key: "country_of_destination", name: "Country of Import", selector: "country_of_destination", dataTip: "", type: "", grow: 1, wrap: true, miWidth: "100px", maWidth: "100px" },
    { key: "fob_value", name: "Shipment Value (USD)", selector: "fob_value", dataTip: "", type: "", sortable: true, grow: 1, wrap: true, isCommaFormat: true, fixedValueUpto: 2, miWidth: "100px", maWidth: "100px" },
  ],
  exporterTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "weight", name: "Net weight (KG)", selector: "weight", sortable: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Value (USD)", selector: "shipment_value", sortable: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Exported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Exported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  importerTableColumn: [
    { key: "id", showUiUeTwoLevel: false, name: "S No.", selector: "id", dataTip: "", type: "", button: true, staticField: true },
    { key: "key", name: "Company Name", selector: "key", selector1: "country", selector1Code: "country_code", selector2: "state", selector3: "address", id: "hashed_id", type: "companyRedirect", fixedLengthUptoRank: 30, fixedLengthUptoTrend: 28, minWidth: "275px" },
    { key: "subKey", showUiUeTwoLevel: true, name: "Random Table", selector: "subKey", grow: 1, wrap: true },
    { key: "doc_count", name: "Shipments", selector: "doc_count", sortable: true, dataTip: "", type: "", isCommaFormat: true, fixedValueUpto: 2 },
    { key: "weight", name: "Net weight (KG)", selector: "weight", sortable: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "shipment_value", name: "Value (USD)", selector: "shipment_value", sortable: true, isCommaFormat: true, fixedValueUpto: 2 },
    { key: "oldest_shipment_date", name: "First Imported On", selector: "oldest_shipment_date", grow: 1, wrap: true },
    { key: "recent_shipment_date", name: "Last Imported On", selector: "recent_shipment_date", grow: 1, wrap: true },
    { key: "market_share", showUiUeTwoLevel: true, isNameVariable: true, name: "% share by", selector: "market_share", type: "", grow: 1, wrap: true },
  ],
  viewShipmentDetails: [
    {
      id: 1,
      title: "",
      growValue: 12,
      isHeader: true,
      imgUrl: "",
      data: [
        { label: "Registration Date", value: "registration_date", dateFormat: true, monthFormat: false },
        { label: "Item Number", value: "itemCount" },
        { label: "Refrendo", value: "refrendo" },
        { label: "Declaration Number", value: "declaration_number" },
        { label: "Bill of Lading Number", value: "bill_of_lading_number" },
        { label: "Mode of Transportation", value: "derived_mode_of_transport_english", tooltip: true, tooltipField: "mode_of_transport_spanish" },
        { label: "Conocimiento EMB", value: "concimento_emb" },
        { label: "HS Code", value: "hs_code" },
        { label: "Product Keywords", value: "product_description" },
      ],
    },
    {
      id: 2,
      title: "Shipment Origin Details",
      isConnectedColumn: true,
      isCompactHeader: true,
      growValue: 6,
      isHeader: false,
      imgUrl: "",
      data: [
        { label: "Country of Export", value: "derived_country_of_export", countryFlag: true, countryCodeField: "derived_country_of_export_code" },
        { label: "Shipper RUC Number", value: "shipper_ruc_number" },
        { label: "Shipper Name", value: "shipper_name" },
        { label: "Shipper Standardized Name", type: "redirect", companyIdKey: "derived_shipper_master_company_id", companyKey: "derived_shipper_master_company", derivedCompanyKey: "derived_shipper_master_name", tradeDirection: "E" },
        { label: "Is Exporter", value: "derived_is_exporter", tooltip: false, tooltipField: "" },
        {
          label: "Shipper Jurisdiction Country",
          value: "derived_shipper_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_shipper_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 3,
      title: "Shipment Destination Details",
      growValue: 6,
      isHeader: false,
      isCompactHeader: true,
      imgUrl: "",
      data: [
        { label: "Country of Import", value: "derived_country_of_import", countryFlag: true, countryCodeField: "derived_country_of_import_code" },
        { label: "Consignee Name", value: "consignee_name" },
        { label: "Consignee Standardized Name", type: "redirect", companyIdKey: "derived_consignee_master_company_id", companyKey: "consignee_name", derivedCompanyKey: "derived_consignee_master_name", tradeDirection: "I" },
        { label: "Is Importer", value: "derived_is_importer" },
        { label: "Port of Unlading", value: "derived_port_of_unlading", type: "redirect", redirectionID: "derived_port_of_unlading_master_id", profileType: redirectingProfileEnum.portOfUnlading.key, tooltip: false, tooltipField: "" },
        {
          label: "Consignee Jurisdiction Country",
          value: "derived_consignee_jurisdiction_country",
          countryFlag: true,
          countryCodeField: "derived_consignee_jurisdiction_country_code",
        },
      ],
    },
    {
      id: 4,
      title: "Customs Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Export Type", value: "derived_export_type_english", tooltip: true, tooltipField: "export_type_spanish", capitalize: "true" },
        { label: "Customs House Name", value: "derived_customs_house_name", capitalize: "true", type: "redirect", redirectionID: "derived_port_of_lading_master_id", profileType: redirectingProfileEnum.portOfLading.key },
        { label: "Customs Agent Code", value: "derived_customs_agent_code" },
        { label: "Customs Agent Name", value: "derived_customs_agent_name", capitalize: "true" },
        { label: "Customs Agency Name", value: "customs_agency_name", capitalize: "true" },
      ],
    },
    {
      id: 5,
      title: "Cargo Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251778/images/website/api-integration/delivery-box_1_1_niaysj.svg",
      data: [
        { label: "Item Number", value: "item_number" },
        { label: "HS Code", value: "hs_code" },
        { label: "Product Description", value: "product_description_translated", isReadMore: true, readMoreLength: 45 },
        { label: "Product Description (Spanish)", value: "product_description", isReadMore: true, readMoreLength: 45 },
        { label: "Product Condition", value: "derived_product_condition_english", tooltip: true, tooltipField: "product_condition_spanish" },
        { label: "Number Of Containers", value: "number_of_containers", isCommaFormat: true },
        { label: "Packages", value: "packages", isCommaFormat: true },
        { label: "Quantity", value: "quantity", dynamicUnit: true, unitField: "derived_unit_of_measure_english", tooltip: true, tooltipField: "quantity", tooltipField2: "unit_of_measure", isCommaFormat: true },
        { label: "FOB Value", value: "fob_value", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Per Unit Value", value: "derived_shipment_value_usd_per_quantity_unit", valuePrefix: "USD ", isCommaFormat: true },
        { label: "Net Weight", value: "net_weight", valueSuffix: " kg", isCommaFormat: true },
      ],
    },
    {
      id: 6,
      title: "Carrier Details",
      growValue: 6,
      isHeader: false,
      imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
      data: [
        { label: "Carrier Name", value: "carrier_name", capitalize: "true" },
        { label: "Vessel Name", value: "vessel_name", capitalize: "true" },
      ],
    },
    // {
    //     id: 6,
    //     title: "Container Details",
    //     growValue: 12,
    //     isHeader: false,
    //     imgUrl: "https://res.cloudinary.com/ddfycftwg/image/upload/v1640251816/images/website/api-integration/ship-gray_1_jqiqaq.svg",
    //     isContainer: true,
    //     mainKey: 'container_details',
    //     uniqueKey: 'id',
    //     data: [
    //         {
    //             title: "Container Identifiers",
    //             titleKey: '',
    //             isNested: false,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Container Number', value: 'container_number', defaultValue: 'NA' },
    //                 { label: 'Seal Number', value: 'seal_number', defaultValue: 'NA' },
    //                 { label: 'Type of Service', value: 'type_of_service', defaultValue: 'NA' },
    //                 { label: 'Load Status', value: 'load_status', defaultValue: 'NA' },
    //                 { label: 'Marks & Numbers', value: 'marks_and_numbers', defaultValue: 'NA' },
    //                 { label: 'Equipment Desc.', value: 'equipment_description', defaultValue: 'NA' },
    //             ]
    //         },
    //         {
    //             title: "Container Dimension",
    //             titleKey: '',
    //             isNested: false,
    //             isContainerDimension: true,
    //             nestedKey: "",
    //             uniqueKey: '',
    //             nestedNumber: '',
    //             childData: [
    //                 { label: 'Length', value: 'length', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Height', value: 'height', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Width', value: 'width', defaultValue: 'NA', isFeet: true, isInch: true },
    //                 { label: 'Type', value: 'type', defaultValue: 'NA' }
    //             ]
    //         },
    //         {
    //             title: "Cargo Description",
    //             titleKey: '',
    //             isNested: true,
    //             nestedKey: "cargo_description_tables",
    //             nestedNumber: 'desc_seq_number',
    //             childData: [
    //                 { label: 'Piece Count', value: 'piece_count', defaultValue: 'NA', dynamicUnit: true, unitField: 'manifest_unit',},
    //                 { label: 'Description', value: 'cargo_description', defaultValue: 'NA', isReadMore: true, readMoreLength: 65,},
    //                 // { label: '', value: 'table', isTable: true, tableHeaderKey: ['HS Code', 'Value (USD)', 'Weight (kg)'], tableContentKey:['hscode', 'value', 'weight'] }
    //             ]
    //         },
    //         {
    //             title: "HAZMAT Sequence",
    //             titleKey: 'hazmat_sequence_number',
    //             isNested: true,
    //             nestedKey: "hazmat_sequence_tables",
    //             nestedNumber: 'hazmat_sequence_number',
    //             childData: [
    //                 { label: 'Sequence Number', value: 'hazmat_sequence_number', defaultValue: 'NA' },
    //                 { label: 'Code', value: 'hazmat_code', defaultValue: 'NA' },
    //                 { label: 'Class', value: 'hazmat_class', defaultValue: 'NA' },
    //                 { label: 'Code Qualifier', value: 'hazmat_code_qualifier', defaultValue: 'NA' },
    //                 { label: 'Contact', value: 'hazmat_contact', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp.', value: 'hazmat_flash_point_temperature', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Negative Ind', value: 'hazmat_flash_point_temperature_negative_ind', defaultValue: 'NA' },
    //                 { label: 'Flash Point Temp. Unit', value: 'hazmat_flash_point_temperature_unit', defaultValue: 'NA' },
    //                 { label: 'Description', value: 'hazmat_description', defaultValue: 'NA' },
    //                 { label: 'Classification', value: 'hazmat_classification', defaultValue: 'NA' },
    //             ]
    //         },
    //     ]
    // },
  ],
  defaultUeUiSecondLevelKey: "country_of_destination",
  twoColumnMapping: {
    trade_country_of_export_to_import: "Trade Routes (Country of Export → Country of Import)",
    derived_consignee_master_name: "Unique Importers",
    derived_shipper_master_name: "Unique Exporters",
    country_of_destination: "Countries of Import",
    customs_house_name: "Customs House Name",
    carrier_name: "Carriers",
    port_of_lading: "Ports Of Unlading",
    derived_mode_of_transport_english: "Mode of Transportation",

    derived_customs_house_name_country_of_destination: "Trade Routes (Customs House Name → Country of Import)",
    six_digit_hs_code: "6 digit HS Codes",
  },
};

const EcuadorExportSearch = () => {
  return <Shipments defaultData={defaultData} analyticDropdownOptions={analyticDropdownOptions} trendsDropdownOptions={trendsDropdownOptions} />;
};
export default EcuadorExportSearch;
